import React, { FunctionComponent, memo } from "react";
import classNames from "classnames";

import { IProps } from "./labeled-field.types";
import "./labeled-field.scss";

/**
 * Wrap any field and display a label
 * @param props.label       Label displayed
 * @param props.children    Field component(s)
 */
const LabeledField: FunctionComponent<IProps> = ({ label, children, name }) => {
    return (
        <div className={classNames("field", "labeled-field")}>
            <label htmlFor={name} className="labeled-field__label" id={`${name}-label`}>
                {label}
            </label>
            {children}
        </div>
    );
};

export default memo(LabeledField);
